import { render, staticRenderFns } from "./MasterplanSquaresTwoSettings.vue?vue&type=template&id=754fc40f&"
import script from "./MasterplanSquaresTwoSettings.vue?vue&type=script&lang=js&"
export * from "./MasterplanSquaresTwoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports